import { CrumbProvider } from 'peach/components/Breadcrumbs/Crumb'
import { LastCompanyIdProvider } from 'peach/scopes/company/LastCompanyIdProvider'

import QueryProvider from 'core/data/QueryProvider'
import { PeachIdLinkProvider } from 'core/helpers/peachIdLink'
import { devToolsPeachIdRoutes } from 'core/resources/peachIdRoutes'

import makeStorage from './storage/makeStorage'
import { StorageProvider } from './storage/StorageProvider'
import { useActiveEnvStorage } from './stores/env'

// Create a default storage for when no environment is active
const defaultStorage = makeStorage('__DEFAULT__')

const AppProviders = ({ children }) => {
  const envStorage = useActiveEnvStorage()
  const storage = envStorage ?? defaultStorage

  return (
    <StorageProvider storage={storage}>
      <LastCompanyIdProvider>
        <QueryProvider>
          <CrumbProvider>
            <PeachIdLinkProvider table={devToolsPeachIdRoutes}>
              {children}
            </PeachIdLinkProvider>
          </CrumbProvider>
        </QueryProvider>
      </LastCompanyIdProvider>
    </StorageProvider>
  )
}

export default AppProviders
